import axios from "axios";
import authHeader from "./auth.header";
const API_URL = "https://contabilidadelider.com/api/wapp/";
class WappService {
    mensagemSetores(setores) {
        return axios.post(
            API_URL + "mensagemSetores",
            {
                setores: setores,
            },
            { headers: authHeader() }
        );
    }
    chatsEmAberto() {
        return axios.get(API_URL + "chatsEmAberto", { headers: authHeader() });
    }
    mensagemHistorico(chatId) {
        //console.log(setores);
        return axios.post(
            API_URL + "mensagemHistorico",
            {
                chatId: chatId,
            },
            { headers: authHeader() }
        );
    }
    listaHistorico() {
        //console.log(setores);
        return axios.post(
            API_URL + "listaHistorico",
            {},
            {
                headers: authHeader(),
            }
        );
    }
    enviarMsg(chatId, body) {
        return axios.post(
            API_URL + "enviarMensagem",
            {
                chatId: chatId,
                body: body,
            },
            { headers: authHeader() }
        );
    }
    colAtendeu(chatId, col) {
        return axios.post(
            API_URL + "colAtendeu",
            {
                chatId: chatId,
                col: col,
            },
            { headers: authHeader() }
        );
    }
    modificarSeen(chatId, seen) {
        return axios.post(
            API_URL + "modificarSeen",
            {
                chatId: chatId,
                seen: seen,
            },
            { headers: authHeader() }
        );
    }
    iniciarNovaConversa(telefone, setor, body) {
        return axios.post(
            API_URL + "novaConversa",
            {
                telefone: telefone,
                setor: setor,
                body: body,
            },
            { headers: authHeader() }
        );
    }
    enviarArquivos(chatId, arquivos, caption) {
        //console.log(arquivos.[0].filename);
        return axios.post(
            API_URL + "enviarArquivos",
            {
                chatId: chatId,
                arquivos: arquivos,
                caption: caption,
            },
            { headers: authHeader() }
        );
    }
    concluirAtendimento(chatId, col) {
        return axios.post(
            API_URL + "fecharAtendimento",
            {
                chatId: chatId,
                col: col,
            },
            { headers: authHeader() }
        );
    }
    mudarSetor(chatId, novoSetor, senderName) {
        return axios.post(
            API_URL + "mudarSetor",
            {
                chatId: chatId,
                novoSetor: novoSetor,
                senderName: senderName,
            },
            { headers: authHeader() }
        );
    }
    /* register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }*/
}

export default new WappService();
